import { Directive, inject, ViewContainerRef } from '@angular/core';

/**
 * Directive that provides access to the ViewContainerRef for dynamically
 * inserting components at runtime.
 *
 * Usage:
 * ```html
 * <ng-template appDynamicContent></ng-template>
 * ```
 *
 * Access the container via a signal query:
 * ```typescript
 * readonly dynamicContent = viewChild.required(DynamicContentDirective);
 * this.dynamicContent().viewContainerRef.createComponent(MyComponent);
 * ```
 */
@Directive({
  selector: '[appDynamicContent]',
})
export class DynamicContentDirective {
  public readonly viewContainerRef = inject(ViewContainerRef);
}
